import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import CityCard from "./citycard"
import Button from "./button"

export default function HomeCities({ stories }) {
  return (
    <>
      <div className="mb-[60px] px-5 mx-auto max-w-[1200px]">
        <StaticImage
          src="../images/PFB_CityRatings_Logo.svg"
          alt="City Ratings Logo"
          placeholder="blurred"
          width={330}
          height={83}
          className="mx-auto"
        />
        <p className="my-[30px] text-xl leading-8">
          PeopleForBikes’ annual City Ratings program measures the quality of
          bike networks in thousands of cities worldwide. By comparing the best
          places for biking, local leaders, decision-makers, and advocates can
          act on key lessons to build more safe, fun, and connected places to
          bike across the U.S.{" "}
          <a
            href="https://cityratings.peopleforbikes.org"
            target="_blank"
            className="underline"
          >
            See how your city scores
          </a>
          .
        </p>
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-4 mb-[60px]">
          {stories.map(story => {
            return <CityCard story={story} key={story.id} />
          })}
        </div>
      </div>
      <div className="flex justify-center my-[60px]">
        <Button
          link={"https://cityratings.peopleforbikes.org"}
          text="See More Cities"
          type="small"
          className="mb-4"
          color="blue"
        />
      </div>
    </>
  )
}
